import React from 'react'

const Commuication = () => {
  return (
    <div>Commuication</div>
  )
}

export default Commuication